import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";
import { ControlledInput } from "../../../common/Input/Input";
import AllDataModal from "./AllDataModal";
import { useState } from "react";
import UserProfileSupportedStatusHistoryDataModal from "./UserProfileSupportedStatusHistoryDataModal";

export default function UserProfileChangeEmailHistoryModal(props) {
	const [showAllDataModal, setShowAllDataModal] = useState(false);
	const [allData, setAllData] = useState();
	const toggleAllDataModal = (e) => {
		if (e) {
			setAllData(e);
		}
		setShowAllDataModal(!showAllDataModal);
	};
	const renderFields = () => {
		let fields = [];
		if (props.listEmailIdChangeHistory) {
			fields = props.listEmailIdChangeHistory.listEmailIdChangeHistory.map(
				(e) => {
					return (
						<tr>
							<td>
								{moment(moment.utc(e["date"]).toDate()).format(
									"MMMM Do YYYY, h:mm:ss a"
								)}
							</td>
							<td>{e["from"]}</td>
							<td>{e["to"]}</td>
							<td>{e["changed_by"]}</td>
						</tr>
					);
				}
			);
		}
		return fields;
	};
	const renderUserMergeHistory = () => {
		let fields = [];
		if (props.listEmailIdChangeHistory) {
			let allEmails = [];
			props.listEmailIdChangeHistory.listUserMergeHistory.map((e) => {
				allEmails.push(e["dictParentData"]["sEmailAddress"]);
				e["dictChildData"].map((f) => {
					allEmails.push(f["sEmailAddress"]);
				});
			});
			fields = props.listEmailIdChangeHistory.listUserMergeHistory.map(
				(e) => {
					return (
						<tr>
							<td style={{ verticalAlign: "top" }}>
								{moment(
									moment.utc(e["dtCreated"]).toDate()
								).format("MMMM Do YYYY, h:mm:ss a")}
							</td>
							<td style={{ verticalAlign: "top" }}>
								{e["sMergedBy"]}
							</td>
							<td style={{ verticalAlign: "top" }}>
								{e["dictRetainedData"]["sEmailAddress"]}
							</td>
							<td style={{ verticalAlign: "top" }}>
								{JSON.stringify(allEmails)}
							</td>
							<td style={{ verticalAlign: "top" }}>
								<a
									style={{
										textDecoration: "underline",
										cursor: "pointer",
									}}
									onClick={() => {
										toggleAllDataModal(e);
									}}
								>
									See Details
								</a>
							</td>
						</tr>
					);
				}
			);
		}
		return fields;
	};

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				<div className="p-2 modals-headers-bar">
					<span>Email Change/ User Merge history</span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={props.toggleModal}
					>
						<X style={{ pointerEvents: "none" }} color="white" />
					</button>
				</div>
				<div
					className="modal-body"
					style={{ overflowY: "scroll", height: "400px" }}
				>
					<span>
						<b>Email Change History</b>
					</span>
					<div>
						{renderFields().length !== 0 ? (
							<table>
								<tr>
									<th>Date</th>
									<th>From</th>
									<th>To</th>
									<th>Changed By</th>
								</tr>
								{renderFields()}
							</table>
						) : (
							<span>No data to show</span>
						)}
					</div>
					<br></br>
					<span>
						<b>User Merge History</b>
					</span>
					<div>
						{renderUserMergeHistory().length !== 0 ? (
							<table>
								<tr>
									<th>Merged On</th>
									<th>Merged By</th>
									<th>Retained Email</th>
									<th>All Emails</th>
									<th>Merge Operation Details</th>
								</tr>
								{renderUserMergeHistory()}
							</table>
						) : (
							<span>No data to show</span>
						)}
					</div>
					<AllDataModal
						isOpen={showAllDataModal}
						toggleModal={toggleAllDataModal}
						allData={allData}
					></AllDataModal>
				</div>
			</ModalContent>
		</Modal>
	);
}
